// 如果想引进更多 vux 组件，请先参考 static/vux 内的 README.md 文档

import Vue from 'vue'
import Vux from 'vux'

Vue.use(Vux.vuxAlertPlugin)
Vue.use(Vux.vuxConfirmPlugin)
Vue.use(Vux.vuxDatetimePlugin)
Vue.use(Vux.vuxLoadingPlugin)
Vue.use(Vux.vuxToastPlugin)

Vue.component('alert', Vux.vuxAlert)
Vue.component('cell', Vux.vuxCell)
Vue.component('group', Vux.vuxGroup)
Vue.component('load-more', Vux.vuxLoadMore)
Vue.component('msg', Vux.vuxMsg)
Vue.component('x-search', Vux.vuxSearch)
Vue.component('sticky', Vux.vuxSticky)
Vue.component('tab', Vux.vuxTab)
Vue.component('tab-item', Vux.vuxTabItem)
Vue.component('x-button', Vux.vuxXButton)
Vue.component('x-input', Vux.vuxXInput)